import { Component, OnInit, inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserLoginService } from '../../../service/user-login.service';
import { ReportMode } from '../../../types';
import { MisidentifiedFaceCloseDialogComponent } from '../../popups/misidentified-face-close-dialog/misidentified-face-close-dialog.component';

@Component({
  selector: 'app-cancellation-details',
  templateUrl: './cancellation-details.component.html',
  styleUrls: ['./cancellation-details.component.scss'],
  standalone: false,
})
export class CancellationDetailsComponent implements OnInit {
  userService = inject(UserLoginService);
  router = inject(Router);
  dialog = inject(MatDialog);

  readonly cancellationId = input<string>(undefined);
  readonly cancelDate = input<string>(undefined);
  readonly location = input<string>(undefined);
  readonly session = input<any>(undefined);
  readonly mode = input<ReportMode>(undefined);
  readonly cancellationItems = input<any>(undefined);
  readonly removeCancellation = output<{ remove: boolean }>();

  items = [];

  loadingData = true;

  formatCancellationItem(item) {
    const bracesArr: any[] = [`$${item.total}`, item.cancel_screen].filter((x) => x !== '');
    return `${item.description} (${bracesArr.join(', ')})`;
  }

  handleDataForbidden(error) {
    if (error.status === 403) {
      try {
        this.router.navigate(['/403']);
      } catch (e) {
        console.error(e);
      }
    }
  }

  ngOnInit(): void {
    const cancellationItems = this.cancellationItems();
    if (cancellationItems) {
      this.items = cancellationItems;
      this.loadingData = false;
    }
  }

  showCloseConfirmationPopup() {
    const dialogRef = this.dialog.open(MisidentifiedFaceCloseDialogComponent, {
      width: '450px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.removeCancellation.emit({ remove: true });
      }
    });
  }
}
